<template>
  <div class="home-wrap">
    <div class="content-wrap">
      <div class="carousel-box">
        <el-carousel height="150px" style="width:100%;border-radius: 6px;">
          <!-- <el-carousel-item v-for="(item,i) in imgList" :key="i">
            <img :src="item" style="width:100%;height:100%;border-radius: 6px;">
          </el-carousel-item> -->
          <el-carousel-item>
            <!-- height:100%; -->
            <img @click="bannerClick" id="banner" src="@/assets/images/banner.png" style="width:100%;border-radius: 6px;">
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="btn-wrap mt-10">
        <div class="btn-box" @click="workClick">
          <el-badge :value="workNum" :max="99" class="item btn-badge" :hidden="workNum === 0">
            <div class="btn-badge-div" style="background-color: #E2F3FE;">
              <img style="height:50px;" src="@/assets/images/work.png" alt="">
            </div>
            <div class="mt-5">故障工单</div>
          </el-badge>
        </div>
        <!-- <div class="btn-box">
          <div style="width:100%">
            <img style="width:100%" src="@/assets/images/center-organ.png" alt="">
          </div>
          <div>巡检工单</div>
        </div>
        <div class="btn-box">
          <div style="width:100%">
            <img style="width:100%" src="@/assets/images/center-person.png" alt="">
          </div>
          <div>设备更换</div>
        </div> -->
        <div class="btn-box" @click="reportClick">
          <div>
            <div class="btn-badge-div" style="background-color: #FEE9E5;">
              <img style="height:50px;" src="@/assets/images/report.png" alt="">
            </div>
          </div>
          <div class="mt-5">故障上报</div>
        </div>
        <!-- <div class="btn-box">
          <div style="width:100%">
            <img style="width:100%" src="@/assets/images/center-person.png" alt="">
          </div>
          <div>故障工单</div>
        </div> -->
      </div>
    </div>

    <el-dialog title="预览" :visible.sync="dialogVisible" top="0" width="100%" class="pdf-dia-wrap">
      <div style="overflow-y: auto;height: 100%;overflow-x: hidden;">
        <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i"></pdf>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import wx from 'weixin-js-sdk';
export default {
  components: { pdf },
  data() {
    return {
      imgList: [],
      workNum: 0,

      pdfSrc: null,
      numPages: undefined,
      dialogVisible: false,

      wxReady: false, // 微信SDK是否已准备就绪
    }
  },
  mounted() {
    // document.addEventListener('touchstart', this.preventStartScroll, { passive: false });
    // document.addEventListener('touchmove', this.preventScroll, { passive: false });
  },
  activated() {
    this.getBannerData();
    this.getTipsNum();
    this.initWeChatSDK();
  },
  methods: {
    preventStartScroll(event) {
      this.startClientY = event.touches[0].clientY;
    },
    preventScroll(event) {
      event.preventDefault();
      if (event.touches[0].clientY - this.startClientY > 100) {
        // alert(1)
      }
    },
    // 初始化微信SDK配置
    async initWeChatSDK() {
      try {
        this.wxReady = false;
        let params = {
          url: window.location.href
        };

        let res = await this.$http.get(this.$API.wechat_getSign, { params });
        const config = res.data;
        wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: ['chooseImage', 'uploadImage', 'getLocalImgData', 'disablePullDownRefresh']
        });
        wx.ready(() => {
          this.wxReady = true;
          console.log('微信SDK配置成功');
        });
        wx.error((res) => {
          console.error('微信SDK配置失败', res);
        });
      } catch (error) {
        console.error('获取微信签名失败', error);
      }
    },
    getTipsNum() {
      let params = {
        status: 1
      }
      this.$http.get(this.$API.repair_order_getProcessingOrdersCountByHanderId, { params }).then(res => {
        this.workNum = res.data || 0;
      })
    },
    getBannerData() {
      this.imgList = [];
    },
    workClick() {
      let url = '/fault/work';
      window.location.assign(url);
      // this.$router.push({ path: '/fault/work' });
    },
    reportClick() {
      let url = '/fault/report';
      window.location.assign(url);
      // this.$router.push({ path: '/fault/report' });
    },
    bannerClick() {
      this.dialogVisible = true;
      this.loadPdf();
    },
    async loadPdf() {
      const loadingTask = pdf.createLoadingTask('http://123.60.131.44:50021/files/prod/energy-carbon/20260202/ab65f95257c4431793b1a53ae3c475d7.pdf')
      this.pdfSrc = loadingTask
      try {
        const pdf = await loadingTask.promise
        this.numPages = pdf.numPages
      } catch (error) {
        console.error('PDF加载失败', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-wrap {
  padding: 10px;
  background-color: #f2f2f2;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  .carousel-box {
    border-radius: 6px;
  }
  .btn-wrap {
    background-color: #fff;
    border-radius: 6px;
    display: flex;
    flex-wrap: wrap;
    .btn-box {
      display: flex;
      width: calc(25% - 20px);
      margin: 10px;
      font-size: 1.4rem;
      flex-direction: column;
      align-items: center;
      .btn-badge-div {
        width: 100%;
        text-align: center;
        padding: 10px;
        border-radius: 4px;
        display: flex;
      }
    }
    .btn-badge {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
.carousel-box {
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }
  .el-carousel__indicator--horizontal {
    .el-carousel__button {
      width: 6px;
      height: 6px;
      border-radius: 6px;
    }
    &.is-active {
      .el-carousel__button {
        width: 12px;
      }
    }
  }
}
.btn-wrap {
  .btn-badge {
    .el-badge__content {
      &.is-fixed {
        top: 10px;
        right: 15px !important;
      }
    }
  }
}
.pdf-dia-wrap {
  &.el-dialog__wrapper {
    overflow-x: hidden;
  }
}
</style>